const DEP_TYPE = process.env.REACT_APP_DEPLOYMENT || "local";

const SERVER_HOSTNAME =
  (DEP_TYPE === "production"
    ? process.env.REACT_APP_SERVER_HOSTNAME_PROD
    : DEP_TYPE === "development"
    ? process.env.REACT_APP_SERVER_HOSTNAME_DEV
    : process.env.REACT_APP_SERVER_HOSTNAME_LOCAL) || "";

const FRONT_HOSTNAME =
  (DEP_TYPE === "production"
    ? process.env.REACT_APP_FRONT_HOSTNAME_PROD
    : DEP_TYPE === "development"
    ? process.env.REACT_APP_FRONT_HOSTNAME_DEV
    : process.env.REACT_APP_FRONT_HOSTNAME_LOCAL) || "";


const CDN_LINK =
  DEP_TYPE === "production"
    ? process.env.REACT_APP_CDN_PROD
    : DEP_TYPE === "development"
    ? process.env.REACT_APP_CDN_DEV
    : "";

const configuration = {
  mode: DEP_TYPE,
  cdnFront: CDN_LINK,
  apiUrl: SERVER_HOSTNAME,
  // vapidKey:
  //   "BBOMlQyxZLRFaRUy0biSBHSgP1Mk8KvPfhp_o0_k7zr7c1Hg6d5xIR5OzCYQfyuT2sQisu8GbQHv6JCHI8iSOYc",
};


export default configuration;